var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { insertAfter } from "AC/helpers/elements";
var jQuery = require("jquery");
var PlacementFactory = /** @class */ (function () {
    function PlacementFactory(meta_type, resetFilters, activeFilters) {
        this.meta_type = meta_type;
        this.activeFilters = activeFilters;
        this.resetFilters = resetFilters;
    }
    PlacementFactory.prototype.create = function () {
        switch (this.getListScreenType()) {
            case 'media':
                return new MediaOverview(this.resetFilters);
            case 'term':
                return new TermOverview(this.resetFilters, this.activeFilters);
            case 'user':
                return new UserOverview(this.resetFilters);
            default:
                return new PostOverview(this.resetFilters);
        }
    };
    PlacementFactory.prototype.getListScreenType = function () {
        var screen_type = this.meta_type;
        if (this.meta_type === 'post' && AC.list_screen === 'wp-media') {
            screen_type = 'media';
        }
        return screen_type;
    };
    return PlacementFactory;
}());
export default PlacementFactory;
var AbstractPlacement = /** @class */ (function () {
    function AbstractPlacement(resetFilters) {
        this.resetFilters = resetFilters;
        jQuery('body').addClass('ac-search-enabled');
    }
    return AbstractPlacement;
}());
var MediaOverview = /** @class */ (function (_super) {
    __extends(MediaOverview, _super);
    function MediaOverview() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MediaOverview.prototype.place = function () {
        var $search_container = jQuery('<div class="ac-search"></div>');
        var $media_filters = jQuery('.wp-filter');
        $media_filters.addClass('search-active');
        $search_container.append(jQuery('#ac-s'));
        $search_container.append($media_filters.find('select'));
        $search_container.append(jQuery('#post-query-submit'));
        $media_filters.addClass('ac-search-active').append($search_container);
        var filterButton = document.querySelector('#post-query-submit');
        if (filterButton) {
            insertAfter(this.resetFilters.getElement(), filterButton);
        }
    };
    return MediaOverview;
}(AbstractPlacement));
var PostOverview = /** @class */ (function (_super) {
    __extends(PostOverview, _super);
    function PostOverview() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PostOverview.prototype.place = function () {
        var resetFilters = this.resetFilters;
        jQuery('.tablenav.top .actions').each(function () {
            var $container = jQuery(this);
            jQuery('body').addClass('ac-search-post');
            if (!$container.hasClass('bulkactions')) {
                $container.removeClass('alignleft').addClass('ac-search').prependTo('.tablenav.top');
                $container.find('#ac-s').prependTo($container);
            }
            var filterButton = document.querySelector('#post-query-submit');
            if (filterButton) {
                insertAfter(resetFilters.getElement(), filterButton);
            }
        });
    };
    return PostOverview;
}(AbstractPlacement));
var TermOverview = /** @class */ (function (_super) {
    __extends(TermOverview, _super);
    function TermOverview(resetFilters, activeFilters) {
        var _this = _super.call(this, resetFilters) || this;
        _this.activeFilters = activeFilters;
        return _this;
    }
    TermOverview.prototype.place = function () {
        var _this = this;
        var $search_container = jQuery('<div class="ac-search"></div>');
        var $button = jQuery('input[name=acp_filter_action]');
        var $filter_container = jQuery('.acp_tax_filters');
        $search_container.append(jQuery('#ac-s')).insertBefore('.tablenav:first .bulkactions').append($button);
        $filter_container.insertBefore($button);
        insertAfter(this.resetFilters.getElement(), $button[0]);
        $button.on('click', function () {
            jQuery(this).parents('form').attr('method', 'get').submit();
        });
        this.activeFilters.onRefresh(function () {
            if (_this.activeFilters.hasActiveFilters()) {
                $button.removeClass('-no-filters');
            }
            else {
                $button.addClass('-no-filters');
            }
        });
    };
    return TermOverview;
}(AbstractPlacement));
var UserOverview = /** @class */ (function (_super) {
    __extends(UserOverview, _super);
    function UserOverview() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UserOverview.prototype.place = function () {
        var $search_container = jQuery('<div class="ac-search"></div>');
        var $button = jQuery('[name=acp_filter_action]');
        $search_container.append(jQuery('#ac-s')).append(jQuery('[class*=acp-filter], .alignleft.actions .acp-range')).append($button);
        insertAfter(this.resetFilters.getElement(), $button[0]);
        jQuery('.tablenav:eq(0)').prepend($search_container);
    };
    return UserOverview;
}(AbstractPlacement));
